import { DynamicAttributeFieldEnumFragment } from "gql/graphql";
import { AnyInput } from "../dynamic-attribute-field-input-types";
import Select from "@/shared/form/select";

type DynamicAttributeFieldEnumProps = AnyInput<{
  meta: DynamicAttributeFieldEnumFragment;
}>;

export function DynamicAttributeFieldEnum({
  meta,
  ...rest
}: DynamicAttributeFieldEnumProps) {
  return (
    <Select
      allowClear
      options={meta.variants.map(({ id, value }) => ({
        label: value.value,
        value: id,
      }))}
      {...rest}
    />
  );
}
